var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delta-container"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"circle"},[_c('div',{staticClass:"sub-title text"},[_vm._v(_vm._s(_vm.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }